@if (loader.isLoading()) {
  <div class="fixed top-0 left-0 w-full h-1 bg-[#e6b012] z-[99999] animate-loader"></div>
}
